import React from 'react';
import './blog-post.css';
import cookies1 from './pictures/cookies1.jpg';
import cookies2 from './pictures/cookies2.jpg';


//import reportWebVitals from './reportWebVitals';

const Cookies22 = () => {

  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header>
                    <h3 className="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>Confidence, Community, and Cookies Event Recap</h2>
                    <p className="site-post-meta">November 19, 2022</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                        On November 10th, we held our Confidence, Community, and Cookies event. We had the
                        opportunity to discuss many topics regarding imposter syndrome as women in tech.
                    </p>
                    <p>
                        We shared our experiences with how confident we are about our accomplishments and
                        what we can do to support other women who feel they can’t share their achievements.
                        We also participated in an activity based on the #IamRemarkable initiative by Google,
                        that promotes empowerment of underrepresented groups in tech.
                    </p>
                    <p>
                        Thank you so much to everyone who was able to make it, we appreciate your vulnerability
                        and participation in our event. We will have more events such as this one in the future
                        and we can’t wait to see you there!
                    </p>
                    <img src={cookies1} alt="Women in Computing members during the discussion" />
                    <img src={cookies2} alt="Women in Computing officers presenting" />
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Cookies22;